import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { useVpnRequest } from '../../Hooks/Features/HelpDesk/useVpnRequest';

const VpnForm = ({ projectOpts, setShowRequestPopup, callApi, editData, setEditData }) => {
    const { vpnRequestUpsert, handleChange, vpnRequestData, approveBy, loader } = useVpnRequest({ projectOpts, setShowRequestPopup, callApi, editData })

    return (
        <div >
            <div className="w30 mt-2">
                <div className="mt-2">Project Name</div>
                <Dropdown className="input-dd" options={projectOpts} optionLabel="project_name" value={vpnRequestData.project_id} onChange={handleChange} placeholder="Project" filter filterInputAutoFocus name="project_id" />
            </div>
            <div className="d-flex gap-1 mt-2">
                <div className="d-flex align-items-center justify-content-center">
                    <input
                        type="radio"
                        id="existing"
                        name="is_prod"
                        value={0}
                        onChange={(e) => handleChange(e, true)}
                        checked={vpnRequestData.is_prod === "0"}
                        style={{ marginLeft: 0 }}
                    />
                    <label htmlFor="existing">
                        DEV/QA
                    </label>
                </div>
                <div className="d-flex align-items-center">
                    <input
                        type="radio"
                        id="new"
                        name="is_prod"
                        value={1}
                        onChange={(e) => handleChange(e, true)}
                        checked={vpnRequestData.is_prod === "1"}
                    />
                    <label htmlFor="new">
                        PROD
                    </label>
                </div>
            </div>
            <div className="row mt-2">
                <div className='col-4 inspectra-calendar'>
                    <label>From Date</label>
                    <Calendar
                        className='input-dd'
                        dateFormat='dd-mm-yy'
                        style={{ height: "100%" }}
                        placeholder="From Date"
                        name='from_date'
                        value={vpnRequestData?.from_date}
                        onChange={handleChange}
                        minDate={new Date()}
                    />
                </div>

                <div className='col-4 inspectra-calendar'>
                    <label>To Date</label>
                    <Calendar
                        className='input-dd'
                        dateFormat='dd-mm-yy'
                        style={{ height: "100%" }}
                        placeholder="To Date"
                        name='to_date'
                        value={vpnRequestData?.to_date}
                        onChange={handleChange}
                        minDate={vpnRequestData?.from_date ? new Date(vpnRequestData?.from_date) : new Date()}
                        maxDate={
                            vpnRequestData?.from_date
                                ? new Date(new Date(vpnRequestData.from_date).setMonth(new Date(vpnRequestData.from_date).getMonth() + 1))
                                : null
                        }
                    />
                </div>

            </div>

            {approveBy?.length > 0 &&
                <div>
                    <div className="mt-2">Approve By</div>
                    <div className="d-flex gap-1 mt-2" >
                        {approveBy.map((item) => (<div>
                            {item.user_code !== null &&
                                <div key={item?.user_code} className="d-flex align-items-center">
                                    <input type="radio" id={item?.user_code} name="approver_user_code" value={item?.user_code} onChange={handleChange} checked={parseInt(vpnRequestData?.approver_user_code) === item?.user_code} />
                                    <label htmlFor={item?.user_code} name="approve_by">{item.user_display_name}</label>
                                </div>
                            }
                        </div>
                        ))}
                    </div>
                </div>
            }
            <div className="mt-2">Reason for vpn</div>
            <div>
                <textarea rows={2} placeholder="Write reason for vpn" className="w100 form-control border" name="reason" value={vpnRequestData.reason} onChange={handleChange} />
            </div>
            <div className="d-flex justify-content-between">
                {vpnRequestData.reason?.trim()?.split(" ")?.length > 5 ? <span></span> :
                    <span>{vpnRequestData.reason?.split(" ")?.[0]?.length === 0 ? 0 : vpnRequestData.reason?.trim()?.split(" ")?.length}/5 words</span>
                }
                <div className="d-flex justify-content-end align-items-center mt-3">
                    <button className="button btn-default" onClick={() => { setShowRequestPopup(false); setEditData({}) }}>Cancel</button>
                    {
                        loader ? <button className="button btn-primary" style={{ width: "60px", height: "30px" }}>
                            <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                            <button className="button btn-primary" onClick={vpnRequestUpsert}>Submit</button>
                    }
                </div>
            </div>
        </div>
    )
}

export default VpnForm